import React from 'react';

// Constants
import PageUrls from 'Shared/constants/PageUrls.constants';
import ExternalLinksConstants from 'Shared/constants/ExternalLinks.constants';

// Components
import { WpPageLayout, WpPageHeader, WpPageBody } from 'Wpds/components/page-layout';
import { WpButton } from 'Wpds/components/button';
import { WpIllustration, Illustrations } from 'Wpds/components/illustration';

// Styles
import './RootErrorPage.scss';

const RootErrorPage = () => {
  const handleBackHomeClick = () => {
    window.location.href = PageUrls.HOME_PAGE;
  };

  const baseClassName = 'RootErrorPage';
  return (
    <WpPageLayout className={baseClassName}>
      <WpPageHeader>
        <WpIllustration
          className={`${baseClassName}__logo`}
          src={Illustrations.pi_logo_full_red_with_text}
          alt="The Predictive Index logo"
        />
      </WpPageHeader>
      <WpPageBody>
        <div className={`${baseClassName}__body`}>
          <WpIllustration
            className={`${baseClassName}__body__img`}
            src={Illustrations.person_working_from_bench_white_bg}
            alt="Ooops something went wrong!"
          />
          <h3 className={`${baseClassName}__body__title`}>Ooops something went wrong!</h3>
          <p className={`${baseClassName}__body__text`}>
            Looks like we hit a snag. Your experience is what matters most, so a fix is top priority. We’re on it.{' '}
          </p>
          <p className={`${baseClassName}__body__text`}>
            In case you don’t know, you can{' '}
            <a href={ExternalLinksConstants.contact_us} target="_blank" rel="noopener noreferrer">
              contact support
            </a>{' '}
            at anytime.
          </p>
          <WpButton size="lg" onClick={handleBackHomeClick}>
            Back Home
          </WpButton>
        </div>
      </WpPageBody>
    </WpPageLayout>
  );
};

export default RootErrorPage;
